import { createStore, combineReducers } from 'redux'
import { StoreState } from './interfaces'
import MessagesReducer from './messages/reducer'
import NotificationsReducer from './notifications/reducer'

// Make store available on Redux devTools chrome extension
// TODO: add composeEnhancers to createStore if env not PROD
// const composeEnhancers = (window as any).__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose
export const initialState: StoreState = {
  messages: {
    unread: 0,
  },
  notifications: {
    unread: 0,
    total: 0,
    list: [],
    error: null,
    isFetching: false,
    hasLoaded: false,
    allNotificationsLoaded: false,
    attrs: {
      warningScheduleRemovalDismissed: true,
    },
  },
}

export let currentState: StoreState = initialState

export const updateState = (state: StoreState): StoreState => (currentState = state)

const reducers = combineReducers({
  messages: MessagesReducer,
  notifications: NotificationsReducer,
})

const store = createStore(reducers, initialState)
export default store
